import EmployeeRegisterUnderLabourReport from "features/Report/components/employeeHistoryGroup/EmployeeRegisterUnderLabourReport";
import useEmployeeUnderLabour from "features/Report/hooks/employeeHistoryGroup/useEmployeeUnderLabour";

const EmployeeRegisterUnderLabourReportPage = () => {
    const useEmployeeUnderLabourProps = useEmployeeUnderLabour();
    return (
        <EmployeeRegisterUnderLabourReport {...useEmployeeUnderLabourProps} />
    )
}
export default EmployeeRegisterUnderLabourReportPage;